export default __webpack_public_path__ + "static/media/signup.b9fbea54.png";